<form [formGroup]="userdataForm" class="standard-form" (ngSubmit)="onSubmit()">
  <mat-form-field appearance="fill">
    <mat-label>{{'FirstName' | translate }}</mat-label>
    <input matInput formControlName="firstName" [errorStateMatcher]="matcher" placeholder="Enter the name...">
    @if (userdataForm.controls['firstName'].hasError('minlength') && !userdataForm.controls['firstName'].hasError('required')) {
      <mat-error>
        {{'FieldRequiredMoreThanTwoChar' | translate }}
      </mat-error>
    }
    @if (userdataForm.controls['firstName'].hasError('required')) {
      <mat-error [innerHtml]="'FieldRequired' | translate">
      </mat-error>
    }
  </mat-form-field>
  <br>
    <mat-form-field appearance="fill">
      <mat-label>{{'LastName' | translate }}</mat-label>
      <input matInput formControlName="lastName" placeholder="Enter the surename...">
      @if (userdataForm.controls['lastName'].hasError('minlength') && !userdataForm.controls['lastName'].hasError('required')) {
        <mat-error>
          {{'FieldRequiredMoreThanTwoChar' | translate }}
        </mat-error>
      }
      @if (userdataForm.controls['lastName'].hasError('required')) {
        <mat-error [innerHtml]="'FieldRequired' | translate">
        </mat-error>
      }
    </mat-form-field>
    <br>
      <mat-form-field appearance="fill">
        <mat-label>{{'DocumentNr' | translate}}</mat-label>
        <input matInput formControlName="documentNr" placeholder="Enter the document ID...">
        @if (userdataForm.controls['documentNr'].hasError('minlength') && !userdataForm.controls['documentNr'].hasError('required')) {
          <mat-error>
            {{'FieldRequiredMoreThanFiveChar' | translate}}
          </mat-error>
        }
        @if (userdataForm.controls['documentNr'].hasError('required')) {
          <mat-error [innerHtml]="'FieldRequired' | translate">
          </mat-error>
        }
      </mat-form-field>
      <br>
        <div class="cbx-accept">
          <mat-checkbox formControlName="regulationAccept"
            class="example-margin">
            {{'AcceptRules' | translate }}
          </mat-checkbox>
          <br><br>
          <mat-checkbox formControlName="dataProcessAccept"
            class="example-margin">
            {{'AcceptPersonalData' | translate }}
          </mat-checkbox><br><br>
          <span>{{'AcceptPrivacyRules' | translate}}
          </span>
        </div>
        <!-- <button (click)="executeImportantAction()">Important action</button> -->
        <br>
          <div class="form-btn-wrapper">
            <button mat-raised-button color="primary" type="submit" [disabled]="!userdataForm.valid">
              @if (loading) {
                <span class="spinner-border spinner-border-sm mr-1"></span>
              }
              {{'Next' | translate }}
            </button>
          </div>
        </form>